export default "__VITE_ASSET__DZrnR2CF__"